// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__J0ETz","buttons":"RemoveExpirationActionButtons_buttons__3tWFT"};